// src/lib/tracking/tracker.ts
// ════════════════════════════════════════════════════════════════════════════
// MATOMO TRACKER PRIMITIVES
// Used by useTest.ts and Matomo.svelte - you probably don't need to import this directly
// ════════════════════════════════════════════════════════════════════════════

import type { Tracker } from './types';
import { dev } from '$app/environment';
let instance = $state<Tracker | null>(null);

/**
 * Tracker store - used by Matomo.svelte to set the instance
 */
export const tracker = {
  get current() {
    return instance;
  },
  set(value: Tracker | null) {
    instance = value;
  },
};

/**
 * Track an event
 */
export function trackEvent(
  category: string,
  action: string,
  name?: string,
  value?: number
): void {
  if (!instance) {
    if (dev) {
      console.warn('[Matomo] Tracker not initialized, skipping:', category, action);
    }
    return;
  }
  instance.trackEvent(category, action, name, value);
}

/**
 * Set a custom dimension
 */
export function setCustomDimension(id: number, value: string): void {
  instance?.setCustomDimension(id, value);
}

/**
 * Track a goal conversion
 */
export function trackGoal(goalId: number, revenue?: number): void {
  instance?.trackGoal(goalId, revenue);
}